import { useState, useEffect } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    }

    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  const handleDismiss = () => {
    setShowInstallButton(false);
  };

  if (!showInstallButton) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg shadow-2xl p-4 z-50 animate-slide-up">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-white/70 hover:text-white transition-colors"
        aria-label="Close"
      >
        <i className="ri-close-line text-xl"></i>
      </button>
      
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
          <i className="ri-smartphone-line text-2xl text-blue-900"></i>
        </div>
        
        <div className="flex-1">
          <h3 className="font-bold text-lg mb-1">Install FNB Loans App</h3>
          <p className="text-sm text-white/90 mb-3">
            Get quick access to loan applications right from your home screen!
          </p>
          
          <div className="flex gap-2">
            <button
              onClick={handleInstallClick}
              className="flex-1 bg-white text-blue-900 font-semibold py-2 px-4 rounded-lg hover:bg-blue-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-download-line mr-2"></i>
              Install Now
            </button>
            <button
              onClick={handleDismiss}
              className="px-4 py-2 text-white/90 hover:text-white transition-colors whitespace-nowrap"
            >
              Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
